import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import "../ficha-master.css";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Swal from "sweetalert2";
import FormInput from "../../../../nuup/componentes/Forms/FormInput.jsx";
import FormSelectApi from "../../../../nuup/componentes/Forms/FormSelectApi.jsx";
import Api from "../../../../api/global.service.js";
import BlockUi from 'react-block-ui';

const ModalFichaCoopNuevoProyecto = forwardRef((props, ref) => {
  const [show, setShow] = useState(false);
  const [blocking, setBlocking] = useState(false);
  const [error, setError] = useState("");
  const [idCooperativa, setIdCooperativa] = useState(0);
  const [fichaMaster, setFichaMaster] = useState();
  const [preguntasSeleccionadas, setPreguntasSeleccionadas] = useState([]);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    clearErrors,
  } = useForm({
    resolver: async (data, context, options) => {
      return yupResolver(schema)(data, context, options);
    },
    mode: "onBlur",
    defaultValues: {
      nombre: "",
      descripcion: "",
    },
  });

  const validFileExtensions = { xlsForm: ["xls", "xlsx"] };

  function isValidFileType(fileName, fileType) {
    return (
      fileName &&
      validFileExtensions[fileType].indexOf(fileName.split(".").pop()) > -1
    );
  }

  const schema = yup.object().shape({
    id_cooperativa: yup.number().min(1, "Seleccione una cooperativa"),
    nombre: yup.string().required("El nombre es requerido"),
    descripcion: yup.string().required("La descripción es requerida")
  });

  //To call outside
  useImperativeHandle(ref, () => ({
    show: showHandler,
    setData: (data) => setFichaMaster(data),
  }));

  const showHandler = () => {
    setShow(true);
  };

  const closeHandler = () => {
    props.onFinish();
    setShow(false);
  };


  const onSubmit = async (values) => {
    try {
      setBlocking(true);
      const formData = new FormData();

      for (var key in values) {
        let v = values[key];
        formData.append(key, v);
      }

      formData.append("id_ciclo", fichaMaster.id_ciclo);
      formData.append("id_cultivo", fichaMaster.id_cultivo);
      formData.append("parent", fichaMaster.id_kobo_ficha_principal);

      Api.createMultiPart("ficha/kobo/coop/proyecto", formData)
        .then((response) => {
          setBlocking(false);
          closeHandler();
        })
        .catch((e) => {
          setBlocking(false);
          if (e.response.status === 422) {
            setError(e.response.data.message);
          } else {
            setError("Error al guardar");
          }
        });


    } catch (e) {
      setBlocking(false);
      await Swal.fire({
        icon: "error",
        title: "",
        text: e.response.data.message,
      });
    }
  };


  return (
    <div
      className="modal"
      style={{
        display: show ? "block" : "none",
        backgroundColor: "rgba(0,0,0,0.2)",
      }}
    >
      <div className="modal-dialog" style={{ width: 550 }}>
        <div className="modal-content" style={{ height: "100%" }}>
          <div className="modal-header" style={{ flex: "inherit" }}>
            <h4 className="modal-title">{props.title}</h4>
            <button
              onClick={() => closeHandler()}
              type="button"
              className="btn"
              style={{ borderRadius: "20px 20px 20px 20px" }}
            >
              <i className="fa fa-times"></i>
            </button>
          </div>
          <div className="modal-body">
            <p className="ficha-nota">
              {"NOTA: Se asociará un nuevo formulario de kobo relacionada a: "}{" "}
              <span style={{ fontWeight: "bold" }}>{fichaMaster?.nombre}</span>
            </p>
            {error && (
              <p className="ficha-error">
                <span>{error}</span>
              </p>
            )}
          <BlockUi tag="div" message="" blocking={blocking} renderChildren={true}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="m-b-15">
                <FormSelectApi
                  id="id_cooperativa"
                  name="id_cooperativa"
                  label="Cooperativa"
                  url="cooperativas"
                  keyArray="id"
                  labelArray="nombre"
                  showLoading={false}
                  onChange={(e) => {
                    setIdCooperativa(e.target.value);
                  }}
                  error={errors.id_cooperativa}
                  onFinish={() => {}}
                  register={register}
                />
              </div>

              <div className="m-b-15">
                <FormInput
                  id="nombre"
                  type="text"
                  name="nombre"
                  label=""
                  placeholder="Nombre"
                  error={errors.nombre}
                  register={register}
                />
              </div>

              <div className="m-b-15">
                <FormInput
                  id="descripcion"
                  type="text"
                  name="descripcion"
                  label=""
                  placeholder="descripcion"
                  error={errors.descripcion}
                  register={register}
                />
              </div>



              {!blocking && (
                <button
                  type="submit"
                  className="btn btn-sirio"
                  style={{ borderRadius: "20px 20px 20px 20px" }}
                >
                  <i className="fa fa-save"></i> Guardar
                </button>
              )}
            </form>
            </BlockUi>
          </div>
        </div>
      </div>
    </div>
  );
});

export default ModalFichaCoopNuevoProyecto;
